module.exports = __webpack_public_path__ + "img/linear_vs_log_scale.a5e7c71d.png";